import React, { useState, useEffect } from "react";
import clsx from "clsx";
import allQuestions from "./questions";
import { useNavigate } from "react-router-dom";

export default function RandomQuiz() {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
    setQuestions(shuffled.slice(0, 10));
  }, []);

  const handleAnswer = (option) => {
    setSelected(option);
    setShowAnswer(true);
    if (option === questions[current].answer) setScore((p) => p + 1);
  };

  const handleNext = () => {
    const next = current + 1;
    if (next < questions.length) {
      setCurrent(next);
      setSelected(null);
      setShowAnswer(false);
    } else {
      setFinished(true);
    }
  };

  return (
    <div>
      <button
        onClick={() => navigate("/")}
        className="fixed bottom-3 left-3 sm:bottom-6 sm:left-6 z-50 px-3 py-2 sm:px-4 sm:py-2.5 rounded-xl bg-white/90 backdrop-blur border shadow hover:shadow-md"
        >
        ← На главную
      </button>
      <div className="relative z-10 p-6 max-w-xl mx-auto rounded-2xl shadow mt-6 bg-white/50 backdrop-blur">
        {finished ? (
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Тест завершён!</h2>
            <p className="text-xl">Ваш результат: {score} из {questions.length}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 text-xl bg-blue-600 text-white px-6 py-4 rounded-2xl hover:bg-blue-700 shadow-md"
            >
              Пройти ещё раз
            </button>
          </div>
        ) : questions.length > 0 ? (
          <div>
            <div className="mb-2 text-gray-600 text-lg">
              Вопрос {current + 1} из {questions.length}
            </div>
            <h3 className="text-2xl font-semibold mb-6">{questions[current].question}</h3>

            <div className="flex flex-col gap-6 w-full">
              {questions[current].options.map((option, index) => {
                const isCorrect = option === questions[current].answer;
                const isSelected = option === selected;

                const buttonClass = clsx(
                  "block w-full text-left text-2xl font-medium py-6 px-8 rounded-2xl shadow-md transition",
                  {
                    "bg-green-300": showAnswer && isCorrect && isSelected,
                    "bg-red-300": showAnswer && !isCorrect && isSelected,
                    "bg-blue-50 hover:bg-blue-100": !showAnswer || !isSelected,
                  }
                );

                return (
                  <button
                    key={index}
                    onClick={() => !showAnswer && handleAnswer(option)}
                    disabled={showAnswer}
                    className={buttonClass}
                  >
                    {option}
                  </button>
                );
              })}
            </div>

            {showAnswer && (
              <div className="mt-6 text-center">
                {selected === questions[current].answer ? (
                  <p className="text-green-600 font-bold text-xl">Правильно!</p>
                ) : (
                  <p className="text-red-600 font-bold text-xl">
                    Неверно. Правильный ответ: {questions[current].answer}
                  </p>
                )}
                <button
                  onClick={handleNext}
                  className="mt-6 text-xl bg-blue-600 text-white px-6 py-4 rounded-2xl hover:bg-blue-700 shadow-md"
                >
                  Далее
                </button>
              </div>
            )}
          </div>
        ) : (
          <p className="text-center text-lg">Загрузка вопросов...</p>
        )}
      </div>
    </div>
    
  );
}
